<template>
  <div>
    <PageCards v-for="(cardId,index) in cardIds" :key="index" :cardId="cardId"/>
  </div>
</template>
<script>
import PageCards from "./PageCards.vue"

export default {
  components: {PageCards},
  name: "PageCardsMenu",
  data() {
    return {
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      cardIds: [],
    }
  },
  mounted() {
    //获取router中的params
    this.getUserMenu()
  },
  methods: {
    // 获取用户菜单
    async getUserMenu() {
      if (!this.user.menus) return
      // 获取当前菜单
      let thisMenu = await this.getMenuChildren(this.user.menus,this.$route.path)
      // 判断是否包含cardIds
      this.getQueryParameters(thisMenu)
    },
    async getMenuChildren(menus,path){
      if (!menus || menus.length === 0) return
      for (const menu of menus) {
        if (menu.children && menu.children.length > 0) {
          let _menu = await this.getMenuChildren(menu.children,path)
          if (_menu) {
            return _menu
          }
        } else {
          if (menu.path === path) {
            return menu
          }
        }
      }
      return null
    },
    // 获取路由参数
    getQueryParameters(thisMenu) {
      if (thisMenu) {
        if (thisMenu.description && thisMenu.description.indexOf(":") !== -1) {
          let params = thisMenu.description.split(",")
          console.log("params",params)
          let itemParams = {}
          params.forEach(param => {
            let key = param.split(":")[0]
            let value = param.split(":")[1]
            itemParams[key] = value
          })
          // 获取cardIds
          if (itemParams.cardIds) {
            this.cardIds = itemParams.cardIds.split(",").map(Number)
            return
          }
        }
      } else {
        //当前路由不存在，跳转404
        this.$router.push({path: "/404"})
      }
    }
  }
}
</script>
<style scoped>

</style>